import { ActivePanelManager, TitledContainer } from '@infotech-soe/erp-ui-kit';
import React, { memo, useMemo } from 'react';

import TotalsForm from '../../../dataset/components/TotalsForm';
import DatasetGridContainer from '../../../dataset/DatasetGridContainer';
import { useStyles } from '../../styles';

import { CategoryDatasetContainerProps } from './CategoryDatasetContainer';
import Title from './Title';

const CategoryDataset: React.FC<CategoryDatasetContainerProps> = ({
  datasetCreated,
  datasetId,
  isCommandsCreated,
  showCommands, // TODO: rename or change logic: showRawDS
  tabIndex,
  fullCount,
  rowsCount,
  selected,
  title,
}) => {
  const classes = useStyles();
  const grid = useMemo(
    () => <DatasetGridContainer id={datasetId} />,
    [datasetId]
  );

  const enhancedTitle = useMemo(
    () => (
      <Title
        className={classes.title}
        datasetId={datasetId}
        fullCount={fullCount}
        isCommandsCreated={isCommandsCreated}
        rowsCount={rowsCount}
        selected={selected}
        title={title}
      />
    ),
    [
      classes.title,
      datasetId,
      fullCount,
      isCommandsCreated,
      rowsCount,
      selected,
      title,
    ]
  );

  return datasetCreated ? (
    showCommands ? (
      <ActivePanelManager.Panel tabIndex={tabIndex}>
        <TitledContainer title={enhancedTitle}>
          <div className="full-height column no-wrap">
            <div className="col">{grid}</div>
            <TotalsForm datasetId={datasetId} />
          </div>
        </TitledContainer>
      </ActivePanelManager.Panel>
    ) : (
      grid
    )
  ) : null;
};

export default memo(CategoryDataset);
